var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 18,
    height: 18,
    rx: 3,
    fill: "#40C706",
    stroke: "#40C706",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2096_26664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.29375 16.7218L5.79375 13.2218C5.44375 12.8329 5.44375 12.2773 5.79375 11.8885C6.14375 11.5551 6.72708 11.5551 7.13542 11.8885L9.99375 14.7773L17.8688 7.27734C18.2188 6.94401 18.8021 6.94401 19.1521 7.27734C19.5021 7.66623 19.5021 8.22179 19.1521 8.61068L10.6354 16.7218C10.2854 17.1107 9.70208 17.1107 9.29375 16.7218Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2096_26664"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    fill: "white",
    transform: "translate(5.5 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkboxChecked.35de5025bf453d8ffdf5d8eb6cd68cc0.svg";
export { ForwardRef as ReactComponent };